import React from "react";
import { TablePagination } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { setUpdateLicenceManagement } from "../../../../common/slice";
import { translate } from "../../../../common/providers";

export default function PaginationBlock() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const dispatch = useDispatch();
	const handleChangePage = (event, newPage) => {
		dispatch(
			setUpdateLicenceManagement({
				listAllCompanies: {
					...licenceManagementStore.listAllCompanies,
					params: { ...licenceManagementStore.listAllCompanies.params, page: newPage },
				},
			})
		);
	};

	const handleChangeRowsPerPage = (event) => {
		dispatch(
			setUpdateLicenceManagement({
				listAllCompanies: {
					...licenceManagementStore.listAllCompanies,
					params: { ...licenceManagementStore.listAllCompanies.params, page: 0, limit: event.target.value },
				},
			})
		);
	};
	return (
		<TablePagination
			component="div"
			count={licenceManagementStore?.listAllCompanies?.totalElements}
			labelRowsPerPage={translate("common:pagination.row-per-page")}
			page={licenceManagementStore?.listAllCompanies?.params?.page}
			rowsPerPage={licenceManagementStore?.listAllCompanies?.params?.limit}
			rowsPerPageOptions={[25, 50, 75]}
			onPageChange={handleChangePage}
			onRowsPerPageChange={handleChangeRowsPerPage}
		/>
	);
}
